// extracted by mini-css-extract-plugin
module.exports = {"purchaseList":"styles_purchaseList__3EswM"};